/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Résultat d'un remplacement de masse.
 */
export interface ImportLineReplaceResultDto {
    replacedCells?: number;
    affectedRows?: number;
    /** Lignes ignorées parce qu'elles étaient déjà importées. */
    skippedImportedRows?: number;
    mode?: string;
}
